export function formattedGameCode (code) {
  if (!code) {
    return null
  }

  // Ensure it's 6 digits and formatted like 123-456
  return code.replace(/(\d{3})(\d{3})/, '$1 $2')
}
